__turbopack_context__.v({
  "button": "GQaH_G_button",
  "button_web3": "GQaH_G_button_web3",
  "checkboxConteiner": "GQaH_G_checkboxConteiner",
  "contact-form__disclaimer": "GQaH_G_contact-form__disclaimer",
  "contact-form__disclaimer_web3": "GQaH_G_contact-form__disclaimer_web3",
  "input": "GQaH_G_input",
  "inputGroup": "GQaH_G_inputGroup",
  "inputGroup_web3": "GQaH_G_inputGroup_web3",
  "label": "GQaH_G_label",
  "namesRow_web3": "GQaH_G_namesRow_web3",
  "selectControl": "GQaH_G_selectControl",
  "selectGroup": "GQaH_G_selectGroup",
  "selectGroup_web3": "GQaH_G_selectGroup_web3",
  "selectLabel": "GQaH_G_selectLabel",
  "textAreaGroup": "GQaH_G_textAreaGroup",
  "textAreaGroup_web3": "GQaH_G_textAreaGroup_web3",
});
